import * as React from "react";
import { Button, Result } from "antd";

export interface Props {
	description: React.ReactNode | string;
}

const EmptyState: React.FC<Props> = (props) => {
	return (
		<Result
			status="500"
			title="Oops!"
			subTitle={props.description}
			extra={
				<Button type="primary" onClick={() => (window.location.href = "/dashboard")}>
					Back Home
				</Button>
			}
		/>
	);
};

export default EmptyState;
